import { ZoomableImage } from '@/components/ZoomableImage';
import northStarImage from '@/assets/jl-product/01-jl-as-product-public-safe.webp';
import evidenceMapImage from '@/assets/jl-product/02-evidence-map.webp';
import servicePromiseImage from '@/assets/jl-product/03-service-promise.webp';
import rareIntersectionImage from '@/assets/jl-product/04-rare-intersection.webp';

const proofPanels = [
  {
    title: 'JL-as-a-Product',
    image: northStarImage,
    alt: "Public visual showing JL's finance, systems, and AI-assisted operating model",
    width: 1233,
    height: 1276,
  },
  {
    title: 'Evidence Map',
    image: evidenceMapImage,
    alt: 'Evidence map visual for JL-as-product positioning',
    width: 1448,
    height: 1086,
  },
  {
    title: 'Service Promise',
    image: servicePromiseImage,
    alt: 'Service promise visual for finance operator outcomes',
    width: 1448,
    height: 1086,
  },
  {
    title: 'Rare Intersection',
    image: rareIntersectionImage,
    alt: 'Rare intersection visual for finance, systems, AI, and meaning',
    width: 1448,
    height: 1086,
  },
];

export function ProofMap() {
  return (
    <section id="proof-start" data-guide-label="Proof" className="border-b border-ink/5 bg-paper">
      <div className="mx-auto max-w-[1540px] px-6 py-20 md:py-24">
        <div className="mx-auto max-w-4xl text-center">
          <p className="font-display text-xs uppercase tracking-[0.25em] text-accent">
            Visual proof
          </p>
          <h1 className="mt-3 font-display text-4xl leading-tight tracking-tight md:text-6xl">
            Public proof, shown at inspection size.
          </h1>
          <p className="mx-auto mt-5 max-w-2xl text-lg text-ink/70">
            The public proof surface for the finance craft, systems thinking,
            AI-assisted execution, and founder translation behind the work. No
            client records, screenshots, names, or private financial data.
          </p>
        </div>

        <div className="mt-14 grid gap-14">
          {proofPanels.map((panel) => (
            <figure
              key={panel.title}
              id={panel.title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '')}
              data-guide-label={panel.title}
              className="mx-auto w-full overflow-hidden rounded-sm border border-accent/30 bg-white p-2 shadow-[0_18px_60px_rgba(11,13,16,0.08)]"
              style={{ maxWidth: panel.width + 16 }}
            >
              <ZoomableImage
                src={panel.image}
                alt={panel.alt}
                label={panel.title}
                imageClassName="rounded-[2px]"
                loading={panel.title === 'JL-as-a-Product' ? 'eager' : 'lazy'}
                width={panel.width}
                height={panel.height}
              />
              <figcaption className="px-3 py-3 font-display text-xs uppercase tracking-[0.22em] text-ink/45">
                {panel.title}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
